module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.active) ? _c('div', {
    staticClass: "event-tab"
  }, [_c('div', {
    staticClass: "info wrapper dark fs-small bg-lightest px-4"
  }, [(_vm.eventWarning) ? _c('div', {
    staticClass: "text-center mb-2"
  }, [_c('div', {
    staticClass: "w-100 radius-normal lightest text-nowrap",
    class: ['bg-' + _vm.eventWarning.bgColor]
  }, [_vm._v("\n                    " + _vm._s(_vm.eventWarning.message) + "\n                ")]), _vm._v(" "), (_vm.cancellationReason) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v(_vm._s(_vm.cancellationReason))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "detailLabel bold"
  }, [_vm._v("\n                    Departure:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold p-0"
  }, [_vm._v("\n                    " + _vm._s(_vm.formatDateDots(_vm.event.start) + ' ' + _vm.formatTime(_vm.event.start)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('div', {
    staticClass: "detailLabel bold"
  }, [_vm._v("\n                    Duration:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold p-0"
  }, [_vm._v("\n                    " + _vm._s(_vm.hourToDuration(this.event.duration)) + "\n                ")])]), _vm._v(" "), (_vm.event.product && _vm.event.product.transport && _vm.event.product.transport.length > 0) ? _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('div', {
    staticClass: "detailLabel bold"
  }, [_vm._v("\n                    Transport:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold p-0"
  }, [_vm._v("\n                    " + _vm._s(_vm.event.product.transport.name) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.event.location) ? _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('div', {
    staticClass: "detailLabel bold"
  }, [_vm._v("\n                    Location:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold p-0"
  }, [_vm._v("\n                    " + _vm._s(_vm.event.location) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('div', {
    staticClass: "detailLabel bold"
  }, [_vm._v("\n                    Channel:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold p-0 d-flex flex-row"
  }, [_c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.channelToolTips.agent),
      expression: "channelToolTips.agent"
    }],
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "channelCircle mr-1 radius-circle bg-medium",
    class: {
      'bg-color-4': _vm.salesChannelsStatus.agentCustom,
      'bg-color-3': _vm.salesChannelsStatus.agent,
      'bg-dark': !_vm.salesChannelsStatus.agent
    }
  }), _vm._v(" "), _c('span', [_vm._v("Agents")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.channelToolTips.widget),
      expression: "channelToolTips.widget"
    }],
    staticClass: "d-flex align-items-center ml-2"
  }, [_c('span', {
    staticClass: "channelCircle mr-1 radius-circle bg-medium",
    class: {
      'bg-color-3': _vm.salesChannelsStatus.widget,
      'bg-dark': !_vm.salesChannelsStatus.widget
    }
  }), _vm._v(" "), _c('span', [_vm._v("Widget")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.channelToolTips.me),
      expression: "channelToolTips.me"
    }],
    staticClass: "d-flex align-items-center ml-2"
  }, [_c('span', {
    staticClass: "channelCircle mr-1 radius-circle bg-medium",
    class: {
      'bg-color-3': _vm.salesChannelsStatus.me,
      'bg-dark': !_vm.salesChannelsStatus.me
    }
  }), _vm._v(" "), _c('span', [_vm._v("Me")])])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('div', {
    staticClass: "detailLabel bold"
  }, [_vm._v("\n                    Cutoff:\n                ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.cutoffDescriptionTooltip),
      expression: "cutoffDescriptionTooltip"
    }],
    staticClass: "darker bold p-0"
  }, [_vm._v("\n                    " + _vm._s(_vm.cutoffDescription) + "\n                ")])]), _vm._v(" "), (_vm.event.hasCutOff) ? _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('div', {
    staticClass: "detailLabel bold"
  }, [_vm._v("\n                    Soft Cutoff:\n                ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.cutoffType.description),
      expression: "cutoffType.description"
    }],
    staticClass: "darker bold p-0"
  }, [_vm._v("\n                    " + _vm._s(_vm.cutoffType.label) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('div', {
    staticClass: "detailLabel bold"
  }, [_vm._v("\n                    Rules:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold p-0"
  }, [_vm._v("\n                    " + _vm._s(_vm.rulesDescription ? 'Yes' : 'No') + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper d-flex px-4 pb-0"
  }, [_c('div', {
    staticClass: "w-100 px-3 bg-lighter radius-normal border-medium py-2 mr-0 d-flex flex-column"
  }, [_c('div', {
    staticClass: "border-bottom-light d-flex justify-content-between align-items-center pb-2 mb-2"
  }, [_c('div', {
    staticClass: "text-uppercase fs-smaller darker bold mt-1"
  }, [_vm._v("Prices")]), _vm._v(" "), _c('div', [(_vm.getChannelsWithPrices.length > 0 && !_vm.isGenderPriceLoading) ? _c('v-select', {
    staticClass: "compact-dropdown",
    attrs: {
      "options": _vm.getChannelsWithPrices,
      "disabled": _vm.getChannelsWithPrices.length === 0,
      "label": "channelName",
      "track-by": "channelName",
      "value": _vm.pricesChannel
    },
    on: {
      "input": function($event) {
        return _vm.updatePricesChannel($event)
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-start align-items-center pb-2"
  }, [_c('span', {
    staticClass: "fs-smaller bold darker"
  }, [_vm._v(_vm._s(_vm.getPriceType))])]), _vm._v(" "), (_vm.event.passengerSettings && _vm.event.passengerSettings.format === 2) ? _c('div', {
    staticClass: "d-flex justify-content-between align-items-center pb-2 my-1"
  }, [_c('div', {
    staticClass: "fs-smaller dark bold mt-1"
  }, [_vm._v("Categories")]), _vm._v(" "), _c('div', [(true) ? _c('v-select', {
    staticClass: "compact-dropdown",
    attrs: {
      "options": _vm.getEventGenderPrices,
      "disabled": false,
      "label": "audienceTypeDescription",
      "track-by": "audienceTypeDescription",
      "value": _vm.categorySelection
    },
    on: {
      "input": function($event) {
        return _vm.updateCategory($event)
      }
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.event.eventGenderPrices[0].genderPriceType !== 3) ? _c('div', _vm._l((_vm.getDisplayedPrices(_vm.pricesChannel)), function(price, index) {
    return _c('div', {
      key: index
    }, [(!(price.genderPriceType == 1 && index > 0) && !_vm.isGenderPriceLoading && !price.error) ? _c('div', {
      staticClass: "prices-grid justify-content-between fs-smaller"
    }, [_c('div', {
      staticClass: "dark elipsis mr-2 cursor-default text-uppercase bold"
    }, [_vm._v("\n                                " + _vm._s(_vm.genderPriceName(price)) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex justify-content-end"
    }, [_c('span', {
      staticClass: "darker bold text-nowrap"
    }, [_vm._v(_vm._s(_vm.formatPrice(price.finalPrice)) + " €")])])]) : _vm._e(), _vm._v(" "), (price.error) ? _c('div', [_vm._m(0, true)]) : _vm._e()])
  }), 0) : _c('div', [(_vm.event.passengerSettings && _vm.event.passengerSettings.format !== 2) ? _c('div', _vm._l((_vm.pricesChannel.prices), function(price, index) {
    return _c('div', {
      key: index,
      staticClass: "prices-grid justify-content-between fs-smaller"
    }, [(price.upperBound) ? _c('div', {
      staticClass: "dark mr-2 cursor-default text-uppercase bold"
    }, [_vm._v("\n                                " + _vm._s(((price.lowerBound) + " to " + (price.upperBound))))]) : _c('div', {
      staticClass: "dark mr-2 cursor-default text-uppercase bold d-flex align-items-start justify-content-start"
    }, [_c('span', {
      staticClass: "mr-1"
    }, [_vm._v(_vm._s(((price.lowerBound) + " to")))]), _vm._v(" "), (_vm.event.availabilityType === 1) ? _c('span', {
      staticClass: "d-flex align-items-center fs-large infinity-height"
    }, [_vm._v("∞")]) : _c('span', {
      staticClass: "mr-1"
    }, [_vm._v(_vm._s(_vm.getMaxSeats))])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex justify-content-end"
    }, [_c('span', {
      staticClass: "darker bold text-nowrap"
    }, [_vm._v(_vm._s(_vm.formatPrice(price.finalPrice)) + " €")])])])
  }), 0) : (_vm.categorySelection && _vm.categorySelection.hashedAudience && _vm.event.passengerSettings && _vm.event.passengerSettings.format === 2) ? _c('div', _vm._l((_vm.pricesChannel.prices[_vm.categorySelection.hashedAudience]), function(price, index) {
    return _c('div', {
      key: index,
      staticClass: "prices-grid justify-content-between fs-smaller"
    }, [(price.upperBound) ? _c('div', {
      staticClass: "dark mr-2 cursor-default text-uppercase bold"
    }, [_vm._v("\n                                " + _vm._s(((price.lowerBound) + " to " + (price.upperBound))))]) : _c('div', {
      staticClass: "dark mr-2 cursor-default text-uppercase bold d-flex align-items-start justify-content-start"
    }, [_c('span', {
      staticClass: "mr-1"
    }, [_vm._v(_vm._s(((price.lowerBound) + " to")))]), _vm._v(" "), (_vm.event.availabilityType === 1) ? _c('span', {
      staticClass: "d-flex align-items-center fs-large infinity-height"
    }, [_vm._v("∞")]) : _c('span', {
      staticClass: "mr-1"
    }, [_vm._v(_vm._s(_vm.getMaxSeats))])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex justify-content-end"
    }, [_c('span', {
      staticClass: "darker bold text-nowrap"
    }, [_vm._v(_vm._s(_vm.formatPrice(price.price)) + " €")])])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.isGenderPriceLoading) ? _c('div', {
    staticClass: "d-flex flex-column justify-content-center align-items-center my-2"
  }, [_c('div', {
    staticClass: "fs-small mb-1"
  }, [_vm._v("Loading Prices")]), _vm._v(" "), _c('loader', {
    attrs: {
      "size": "small"
    }
  })], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "display-grid wrapper px-4"
  }, [_c('div', {
    staticClass: "w-100 px-3 bg-lighter radius-normal border-medium py-2 mr-1 d-flex flex-column"
  }, [_c('div', {
    staticClass: "pt-1"
  }, [_c('div', {
    staticClass: "border-bottom-light"
  }, [_c('div', {
    staticClass: "text-uppercase fs-smallest dark"
  }, [_vm._v("Available")]), _vm._v(" "), (_vm.event.availabilityType === 1) ? _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Unlimited'),
      expression: "'Unlimited'"
    }],
    staticClass: "fs-giant"
  }, [_c('i', {
    staticClass: "fas fa-infinity"
  })]) : _c('div', {
    staticClass: "fs-giant"
  }, [_vm._v(_vm._s(_vm.event.quantityAvailable))]), _vm._v(" "), _c('div', {
    staticClass: "mb-4"
  }, [(_vm.totalReserved) ? _c('span', {
    staticClass: "lightest bg-color-1 radius-normal fs-smaller px-1 bold"
  }, [_vm._v(_vm._s(_vm.totalReserved) + " booking\n                            now")]) : _c('span', [_vm._v(" ")])])])]), _vm._v(" "), (_vm.event.availabilityType === 0) ? _c('div', {
    staticClass: "border-bottom-light py-1"
  }, [_c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Total Capacity'),
      expression: "'Total Capacity'"
    }],
    staticClass: "text-uppercase fs-smallest dark bold"
  }, [_vm._v("Total Capacity")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.event.maximumLotation))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-light"
  }, [(_vm.event.eventResources.length < 1) ? _c('div', {
    staticClass: "light h-100 d-flex align-items-center justify-content-center fs-small py-1"
  }, [_vm._v("No resources\n                ")]) : _c('div', {
    staticClass: "pb-1"
  }, _vm._l((_vm.event.eventResources), function(resource) {
    return _c('div', {
      key: resource.id,
      staticClass: "justify-content-between fs-smaller"
    }, [_c('div', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (((resource.name) + " " + ((_vm.event.availabilityType == 2) ? resource.capacityAvailable + '/' + resource.maxSeats : ''))),
        expression: "`${resource.name} ${(event.availabilityType == 2) ? resource.capacityAvailable + '/' + resource.maxSeats : ''}`"
      }],
      staticClass: "dark mr-2 cursor-default text-uppercase bold mt-1"
    }, [_vm._v("\n                            " + _vm._s(resource.name))]), _vm._v(" "), (_vm.event.availabilityType == 2) ? _c('div', {
      staticClass: "d-flex"
    }, [_c('span', {
      staticClass: "darker bold"
    }, [_vm._v(_vm._s(resource.capacityAvailable))]), _vm._v(" "), _c('span', {
      staticClass: "dark bold"
    }, [_vm._v("/" + _vm._s(resource.maxSeats))])]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-light py-1"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-baseline"
  }, [_c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Occupancy'),
      expression: "'Occupancy'"
    }],
    staticClass: "text-uppercase fs-smaller dark bold"
  }, [_vm._v("\n                        Occup...\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.occupancy)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "py-1"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-baseline"
  }, [_c('div', {
    staticClass: "text-uppercase fs-smaller dark bold"
  }, [_vm._v("\n                        Booked\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "bold"
  }, [_vm._v("\n                        " + _vm._s(_vm.event.quantityBooked) + "\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "w-100 px-3 bg-lighter radius-normal border-medium pt-2 ml-1 d-flex flex-column"
  }, [_c('div', {
    staticClass: "py-1"
  }, [_c('div', {
    staticClass: "text-uppercase fs-smallest dark"
  }, [_vm._v("Check-ins")]), _vm._v(" "), _c('div', {
    staticClass: "fs-giant"
  }, [_vm._v(_vm._s(_vm.event.totalPAXCheckedIn) + "/" + _vm._s(_vm.event.totalPAXCheckedIn + _vm.event.totalPAXMissing))])]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-light pb-1"
  }, [_c('div', {
    staticClass: "checkin-grid fs-smaller"
  }, [_c('div', {
    staticClass: "text-uppercase dark bold"
  }, [_vm._v("\n                        No-Shows\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "bold text-right"
  }, [_vm._v("\n                        " + _vm._s(_vm.event.totalPAXNoShow) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase dark bold color-6"
  }, [_vm._v("\n                        Missing\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "bold color-6 text-right"
  }, [_vm._v("\n                        " + _vm._s(_vm.event.totalPAXMissing) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-2 flexGrow1 py-1"
  }, [(_vm.orderedEventOccupancyList.length > 0) ? _c('div', {
    staticClass: "text-uppercase fs-smallest dark pb-2"
  }, [_vm._v("Breakdown")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orderedEventOccupancyList), function(clientType, index) {
    return _c('div', {
      key: index
    }, [(_vm.isToShowThisClientType(clientType)) ? _c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('div', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (_vm.genderPriceName2(clientType)),
        expression: "genderPriceName2(clientType)"
      }],
      staticClass: "dark elipsis flexGrow1 mr-2 text-uppercase bold fs-smaller"
    }, [_vm._v(_vm._s(_vm.genderPriceName2(clientType, 'Order')) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "fs-smaller"
    }, [_c('span', {
      staticClass: "darker bold"
    }, [_vm._v(_vm._s(clientType.quantity))])])]) : _vm._e()])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex justify-content-center align-items-center my-3"
  }, [_c('span', {
    staticClass: "darker bold text-nowrap"
  }, [_vm._v("No information found.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0b0345f3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b0345f3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/EventDetails.vue
// module id = 2713
// module chunks = 0